import { createSlice } from "@reduxjs/toolkit";

export const topbarSlice = createSlice({
	name: "topbar",
	initialState: {
		titlePageCurrent: "",
	},
	reducers: {
		updateTitlePageCurrent: (state, { payload: value }) => ({
			...state,
			titlePageCurrent: value,
		}),
	},
});

export const { updateTitlePageCurrent } = topbarSlice.actions;
export default topbarSlice.reducer;
